import React from "react";
import SingleSpreadContent from "../components/spreads/single-spread-content";

const SingleSpread = () => {
  return <SingleSpreadContent />;
};

export default SingleSpread;
